import { Fragment } from "react"
import "./resources.css"


const Resource = () => {
    return (
        <Fragment>
            <main class="resource-container" role="main">
                <h1>Video <span class="highlight">Resources</span></h1>

                <div class="video-grid" role="list" aria-label="University visits videos list">
                    {/* <!-- Video 1 iframe from user --> */}
                    <div class="video-box" role="listitem" tabindex="0" aria-label="Featured University Visit video">
                        <iframe
                            src="https://youtube.com/embed/OIXdPlacrzY"
                            allow="autoplay; encrypted-media"
                            title="video"
                            allowfullscreen
                        ></iframe>
                    </div>
                    <div class="video-box" role="listitem" tabindex="0" aria-label="Featured University Visit video">
                        <iframe
                            src="https://www.youtube.com/embed/B7hkj__I13M"
                            allow="autoplay; encrypted-media"
                            title="video"
                            allowfullscreen
                        ></iframe>
                    </div>

                    {/* <!-- Placeholder videos replicating grid, 11 more --> */}
                    <div class="video-box" role="listitem" tabindex="0" aria-label="Top 18 Institutes in Canada video">
                        <iframe
                            src="https://www.youtube.com/embed/0Q7DDJF-j0A"
                            allow="autoplay; encrypted-media"
                            title="Top 18 Institutes in Canada"
                            allowfullscreen
                        ></iframe>
                    </div>
                    <div class="video-box" role="listitem" tabindex="0" aria-label="Experience Student Campus Tour video">
                        <iframe
                            src="https://www.youtube.com/embed/fIhcjK1FqXQ"
                            allow="autoplay; encrypted-media"
                            title="Experience Student Campus Tour"
                            allowfullscreen
                        ></iframe>
                    </div>
                    <div class="video-box" role="listitem" tabindex="0" aria-label="Queens University Full Campus Tour video">
                        <iframe
                            src="https://www.youtube.com/embed/-_mMtOWPY2U"
                            allow="autoplay; encrypted-media"
                            title="Queens University Full Campus Tour"
                            allowfullscreen
                        ></iframe>
                    </div>
                    <div class="video-box" role="listitem" tabindex="0" aria-label="Wilfrid Laurier University Tour video">
                        <iframe
                            src="https://www.youtube.com/embed/Z-7Cvj2azgY"
                            allow="autoplay; encrypted-media"
                            title="Wilfrid Laurier University Tour"
                            allowfullscreen
                        ></iframe>
                    </div>
                    
                </div>
            </main>
        </Fragment>
    )
}

export default Resource
